module.exports = __webpack_public_path__ + "img/logo.a658a886.png";